import { useState, useEffect } from 'react';
import 'react-phone-input-2/lib/material.css';
import PhoneInput from 'react-phone-input-2';

const UsePhoneInput = ({
  value,
  onChange,
  containerClass = '',
  inputClass = '',
  inputStyle = '',
  containerStyle = ''
}) => {
  const [defaultCountry, setDefaultCountry] = useState('tr'); // Varsayılan ülke kodu

  // Avrupa ülkeleri + Türkiye, Irak ve Çin
  const allowedCountries = [
    'de',
    'fr',
    'es',
    'it',
    'nl',
    'be',
    'pt',
    'se',
    'no',
    'dk',
    'fi',
    'is',
    'tr',
    'iq',
    'cn'
  ];

  useEffect(() => {
    // Kullanıcının IP'sine göre varsayılan ülkeyi belirleme
    const fetchUserCountry = async () => {
      try {
        const language = navigator.language || navigator.userLanguage;
        const countryCode = language.split('-')[1] || 'tr'; // 'tr' varsayılan
        setDefaultCountry(countryCode);
      } catch (error) {
        console.error('Ülke kodu alınırken hata:', error);
      }
    };

    fetchUserCountry();
  }, []);

  return (
    <PhoneInput
      containerClass={`${containerClass}`} // Tam genişlik için w-full
      inputClass={`${inputClass}`} // Input genişliği
      placeholder="Enter phone number"
      value={value}
      onChange={onChange}
      country={defaultCountry} // Varsayılan ülke
      onlyCountries={allowedCountries} // Ülke listesini buradan alıyoruz
      enableSearch={true} // Arama özelliği
      preferredCountries={['tr', 'iq', 'de']} // Tercih edilen ülkeler
      autoFormat={true} // Otomatik formatlama
      disableCountryCodeChange={true} // Ülke kodu değiştirilemez
      countryCodeEditable={false} // Ülke kodu düzenlenemez
      inputStyle={{ width: '100%' }} // Input genişliği
      containerStyle={{ width: '100%' }} // Container genişliği
    />
  );
};

export default UsePhoneInput;
